import { Route as NonMedicalMasterRoute } from "@/routes/(pharma)/_layout/inventory/non-medical-master/index";
import { useQuery } from "@tanstack/react-query";
import { getNonMedicalMasterItems } from "../-data/api";
import type { NonMedicalMaster } from "@/gen/non_medical_master/common_pb";
import { ListNonMedicalMasterResponse } from "@/gen/non_medical_master/list_non_medical_master_pb";

interface MedicalMasterQueryResult {
    nonMedicalMasters: NonMedicalMaster[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export const useNonMedicalMasterData = () => {
    const searchParams = NonMedicalMasterRoute.useSearch();

    const page = searchParams.page || 1;
    const pageSize = searchParams.pageSize || 10;

    return useQuery<MedicalMasterQueryResult>({
        queryKey: ["medicalmaster", searchParams],
        queryFn: async () => {
            const search = searchParams.search || "";

            let response: ListNonMedicalMasterResponse;

            response = await getNonMedicalMasterItems(page, pageSize, search);

            return {
                nonMedicalMasters: response.nonMedicalMasters,
                totalCount: response. totalCount,
                page,
                pageSize
            };
        },
        // Keep previous data while fetching new data for better UX
        placeholderData: (previousData) => previousData,
        // Don't refetch when window regains focus
        refetchOnWindowFocus: false,
        // Stale time - how long data stays fresh (5 minutes)
        staleTime: 5 * 60 * 1000,
        // Cache time - how long inactive data stays in cache (10 minutes)
        gcTime: 10 * 60 * 1000,
    });
};